import { SimpleObject } from '../../types';

export const objectInOrder = (
  objectSource: SimpleObject,
  fieldOrder: Array<string>,
  omitIfEmpty?: Array<string>
) => {
  const orderedObject = {} as SimpleObject;
  for (let i = 0; i < fieldOrder.length; i++) {
    if (omitIfEmpty && omitIfEmpty.includes(fieldOrder[i]) && !objectSource[fieldOrder[i]]) {
      continue;
    }
    orderedObject[fieldOrder[i]] = objectSource[fieldOrder[i]];
  }
  return orderedObject;
};

/**
 * Safely parse descripcionArtefacto which may arrive as an object (GeoJSON source)
 * or as a JSON string (vector tile source).
 */
export const parseArtifactDescription = (raw: unknown): SimpleObject => {
  if (!raw) return {};
  if (typeof raw === 'object') return raw as SimpleObject;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  return {};
};
